define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWpAssetAttr = void 0;
    class FWpAssetAttr extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WpAssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WpAssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AttrTypeId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AttrTypeIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CurrentValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CurrentValueError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewValueError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FWpAssetAttr.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FWpAsset = parent;
            this.WpAssetId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.FWpAsset = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WpAssetId = (0, EntityUtil_1.toInt)(entity.WpAssetId);
            a.AttrTypeId = (0, EntityUtil_1.toInt)(entity.AttrTypeId);
            a.CurrentValue = b.CurrentValue;
            a.NewValue = b.NewValue;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FWpAssetAttr.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WpAssetId", "Works Project Asset Id");
                this.validateReqNumber(validationState, "AttrTypeId", "Asset Attribute Type Id");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WpAssetId: this.WpAssetId,
                AttrTypeId: this.AttrTypeId,
                CurrentValue: this.CurrentValue,
                NewValue: this.NewValue,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static create(a, type) {
            return new Promise((resolve, reject) => {
                var aa = new FWpAssetAttr(null, a);
                aa.AttrTypeId = type.Id;
                a.FWpAssetAttr.push(aa);
                resolve(aa);
            });
        }
        get AssetAttributeType() {
            if (this.FWpAsset && this.FWpAsset.FWorksProject && this.FWpAsset.FWorksProject.Facility) {
                return this.FWpAsset.FWorksProject.Facility.AssetAttributeTypes.find(aat => aat.Id == this.AttrTypeId);
            }
            else {
                return null;
            }
        }
        get Description() {
            if (this.AssetAttributeType) {
                return this.AssetAttributeType.Desc_;
            }
        }
    }
    exports.FWpAssetAttr = FWpAssetAttr;
    Object.defineProperty(FWpAssetAttr, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FWpAssetAttr"
    });
    Object.defineProperty(FWpAssetAttr, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Works Project Job Asset Attribute"
    });
    Object.defineProperty(FWpAssetAttr, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WpAssetId", "AttrTypeId", "CurrentValue", "NewValue"]
    });
    Object.defineProperty(FWpAssetAttr, "WpAssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpAssetAttr, "AttrTypeIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpAssetAttr, "CurrentValueLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpAssetAttr, "CurrentValueReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpAssetAttr, "NewValueLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpAssetAttr, "NewValueReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetAttr.prototype, "WpAssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetAttr.prototype, "WpAssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetAttr.prototype, "AttrTypeId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetAttr.prototype, "AttrTypeIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetAttr.prototype, "CurrentValue", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetAttr.prototype, "CurrentValueError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetAttr.prototype, "NewValue", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetAttr.prototype, "NewValueError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpAssetAttr.prototype, "FWpAsset", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpAssetAttr.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpAssetAttr.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpAssetAttr.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpAssetAttr.prototype, "AssetAttributeType", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpAssetAttr.prototype, "Description", null);
});
